import { createSlice } from '@reduxjs/toolkit';
import { netbatchJobsInitialState } from '../initialStates/netbatchJobs';

const setNBJobVNCDisplay = (state, action) => {
  state.currentSessionJobs[action.payload.Jobid] = action.payload;
  state.currentSessionJobs[action.payload.Jobid].shouldOpenWindow = false;
};

const setWindowOpened = (state, action) => {
  state.currentSessionJobs[action.payload.Jobid].shouldOpenWindow = false;
};

const setExternalWindow = (state, action) => {
  state.externalWindows[action.payload.Jobid] = action.payload.externalWindow;
};

const unsetExternalWindow = (state, action) => {
  delete state.externalWindows[action.payload.Jobid];
};

const removeJobFromState = (state, action) => {
  delete state.currentSessionJobs[action.payload.Jobid];
};

const setShouldOpenWindow = (state, action) => {
  state.currentSessionJobs[action.payload.Jobid].shouldOpenWindow = true;
};

const netbatchJobsSlice = createSlice({
  name: 'netbatchJobs',
  initialState: netbatchJobsInitialState,
  reducers: {
    setNBJobVNCDisplay,
    setWindowOpened,
    setExternalWindow,
    unsetExternalWindow,
    removeJobFromState,
    setShouldOpenWindow,
  },
});

export const netbatchJobsActions = netbatchJobsSlice.actions;

export default netbatchJobsSlice.reducer;
